import React from 'react';
import { cn } from '@express-labs/raven-tools';

import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const AlertIconBlack: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--alertIconBlack')}
    width="20"
    height="22"
    viewBox="0 0 20 22"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(-148.000000, -183.000000)"
        fill="#17171D"
        fillRule="nonzero"
      >
        <g transform="translate(148.500000, 183.500000)">
          <path d="M8.5,0 C13.1944204,0 17,3.80557963 17,8.5 C17,13.1944204 13.1944204,17 8.5,17 C3.80557963,17 0,13.1944204 0,8.5 C0,3.80557963 3.80557963,0 8.5,0 Z M9.5,12 L7.5,12 L7.5,14 L9.5,14 L9.5,12 Z M9.5,4 L7.5,4 L7.5,10 L9.5,10 L9.5,4 Z" />
        </g>
      </g>
    </g>
  </svg>
);

export default AlertIconBlack;
